import { Outlet, Link, useLocation } from 'react-router-dom';
import { ProfileSidebar } from '@/components/profile/ProfileSidebar';
import { cn } from '@/lib/utils';
import {
  Settings,
  Lock,
  FileText,
  ThumbsUp,
  Activity,
} from 'lucide-react';

const profileNavItems = [
  {
    label: 'Settings',
    href: '/profile/settings',
    icon: Settings,
  },
  {
    label: 'Security',
    href: '/profile/security',
    icon: Lock,
  },
  {
    label: 'Posts',
    href: '/profile/posts',
    icon: FileText,
  },
  {
    label: 'Votes',
    href: '/profile/votes',
    icon: ThumbsUp,
  },
  {
    label: 'Activity',
    href: '/profile/activity',
    icon: Activity,
  },
];

export function ProfileLayout() {
  const { pathname } = useLocation();

  return (
    <div className="flex min-h-screen bg-background">
      {/* Desktop sidebar - hidden on mobile */}
      <div className="hidden lg:block">
        <ProfileSidebar />
      </div>

      <div className="flex-1 flex flex-col">
        {/* Mobile horizontal tabs */}
        <div className="lg:hidden border-b bg-card sticky top-[52px] z-40">
          <div className="overflow-x-auto scrollbar-hide">
            <nav className="flex px-4 py-2 gap-1 min-w-max">
              {profileNavItems.map((item) => {
                const isActive = pathname === item.href || pathname.startsWith(item.href + '/');
                const Icon = item.icon;

                return (
                  <Link
                    key={item.href}
                    to={item.href}
                    className={cn(
                      'flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap',
                      isActive
                        ? 'bg-primary/10 text-primary'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    {item.label}
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Main content */}
        <main className="flex-1 p-4 sm:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
